import React from 'react';
import PropTypes from 'prop-types';
import { ProgressBar } from '@web/atoms';
import { BaseHeader, DiscountBanner } from '@web/molecules';
import { BreadcrumbContainer, CurrentProgress } from './styles';

export const QuizHeader = ({
  currentStep,
  totalSteps,
  showPromoBar,
  discountBannerCopy,
  discountBannerBGColor,
  discountBannerFontColor,
  cro = true,
  centerLogo = false,
  progress = true,
  overrideText = '',
  logoUrl = '/',
}) => {
  const topHeaderSegment = (
    <>
      {showPromoBar && (
        <DiscountBanner
          promoMessage={discountBannerCopy}
          bgColor={discountBannerBGColor}
          fontColor={discountBannerFontColor}
          showLink={false}
        />
      )}
      <BreadcrumbContainer>
        <CurrentProgress>
          {overrideText ? (
            <span>{overrideText}</span>
          ) : (
            <span>
              Step {currentStep} of {totalSteps}
            </span>
          )}
        </CurrentProgress>
        {progress && (
          <ProgressBar
            color="secondary.pallette"
            currentStep={currentStep}
            totalSteps={totalSteps}
            labelText={`Signup step ${currentStep} of ${totalSteps}`}
          />
        )}
      </BreadcrumbContainer>
    </>
  );

  return (
    <BaseHeader
      sticky={true}
      stickyBanner={true}
      cro={cro}
      topSegment={centerLogo ? null : topHeaderSegment}
      withDropShadow={true}
      centerLogo={centerLogo}
      logoUrl={logoUrl}
    />
  );
};

QuizHeader.displayName = 'QuizHeader';

QuizHeader.propTypes = {
  currentStep: PropTypes.number.isRequired,
  totalSteps: PropTypes.number.isRequired,
  showPromoBar: PropTypes.bool,
  discountBannerCopy: PropTypes.string,
  discountBannerBGColor: PropTypes.string,
  discountBannerFontColor: PropTypes.string,
  cro: PropTypes.bool,
  progress: PropTypes.bool,
  overrideText: PropTypes.string,
  logoUrl: PropTypes.string,
};
